/**
 * One vocabulary for everything that moves in the dashboard, so screens animate like one system: one curve
 * for entrances, one duration for most things, one overshoot reserved for the single loud moment of a flow.
 * Values follow the marketing site's motion system so the product and the landing feel related.
 */
export const MOTION_EASE = {
  /** Everything that enters. */
  enter: "power2.out",
  /** A little overshoot. Reserved for a flow's one celebratory moment (a success mark landing). */
  pop: "back.out(1.4)",
  /** Lines and progress driven by state rather than time. */
  linear: "none",
} as const;

export const MOTION_DURATION = {
  quick: 0.22,
  /** Everything that enters. The most used number. */
  enter: 0.6,
  /** The loud moment only. */
  slow: 0.9,
  /** Counters: long enough to read the digits moving. */
  count: 1.6,
} as const;

export const MOTION_STAGGER = {
  tight: 0.05,
  base: 0.07,
  loose: 0.1,
} as const;

/** How far an entering element travels, in px. */
export const MOTION_RISE = 16;
